// AccountHub (admin) — Phase 12.9.
//
// Tabs: Profile + App icons. Both are admin self-service / setup
// surfaces that don't fit anywhere else.

import TabHub, { type TabDef } from '@baaligames/shared-ui/admin/components/TabHub';

const TABS: TabDef[] = [
  { to: '/account/profile',   label: 'Profile',    icon: 'person',  matchPrefix: '/account/profile' },
  { to: '/account/app-icons', label: 'App icons',  icon: 'apps',    matchPrefix: '/account/app-icons' },
];

export default function AccountHub() {
  return (
    <TabHub
      title="Account"
      titleIcon="manage_accounts"
      subtitle="Your profile and PWA app icons"
      tabs={TABS}
    />
  );
}
